var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c(
      "div",
      {
        staticClass:
          "d-sm-flex justify-content-center justify-content-sm-between"
      },
      [
        _c(
          "span",
          {
            staticClass:
              "text-muted text-center text-sm-left d-block d-sm-inline-block"
          },
          [
            _vm._v(
              "\n            Copyright © " + _vm._s(_vm.currentYear) + " "
            ),
            _c(
              "a",
              {
                staticClass: "text-primary",
                attrs: { href: "https://www.aform.lu", target: "_blank" }
              },
              [_vm._v("Aform.lu")]
            ),
            _vm._v(
              "\n              ·  \n            All rights reserved\n              ·  \n            "
            ),
            _c(
              "router-link",
              {
                staticClass: "text-muted",
                attrs: {
                  tag: "a",
                  to: { name: "terms-and-conditions" },
                  target: "_blank"
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("pages.login.t_and_c")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "float-none float-sm-right d-block mt-1 mt-sm-0 text-center"
      },
      [
        _vm._v("\n            Hand-crafted & made with "),
        _c("i", { staticClass: "mdi mdi-heart text-danger" }),
        _vm._v(" by "),
        _c(
          "a",
          {
            staticClass: "text-primary",
            attrs: { href: "https://www.apps.lu", target: "_blank" }
          },
          [_vm._v("Apps.lu")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }